(() => {
  if (!customElements.get("filters-component")) {
    class e extends HTMLElement {
      constructor() {
        super(),
          (this.debouncedOnSubmit = this.debounce((e) => {
            this.onChange(e);
          }, 500)),
          this.querySelector("[data-form]")?.addEventListener(
            "input",
            this.debouncedOnSubmit.bind(this)
          );
      }
      connectedCallback() {
        document.querySelectorAll("[data-filter-opener]").forEach((e) => {
          e.addEventListener("click", this.open.bind(this));
        }),
          this.querySelector("[data-filter-close-button]")?.addEventListener(
            "click",
            this.close.bind(this)
          ),
          this.querySelector("[data-clear]")?.addEventListener(
            "click",
            this.clear.bind(this)
          ),
          this.querySelectorAll("[data-active]").forEach((e) => {
            e.addEventListener("click", this.onRemove.bind(this));
          }),
          this.querySelectorAll("[data-group-button]").forEach((e) => {
            e.addEventListener("click", this.groupToggle.bind(this));
          }),
          this.querySelector("[data-overlay]").addEventListener(
            "click",
            this.close.bind(this)
          );
      }
      open() {
        this.setAttribute("open", !0),
          document.querySelector("html").classList.add("lock-all"),
          document.querySelector("html").classList.add("is-filters-visible");
      }
      close() {
        this.removeAttribute("open"),
          document.querySelector("html").classList.remove("lock-all"),
          setTimeout(() => {
            document
              .querySelector("html")
              .classList.remove("is-filters-visible");
          }, 500);
      }
      groupToggle(e) {
        e.currentTarget.toggleAttribute("close");
      }
      onChange(e) {
        e.preventDefault();
        let t = this.querySelector("[data-form]"),
          i = "";
        if (t) {
          let r = new FormData(t);
          i = new URLSearchParams(r).toString();
        }
        let l = new URL(location.href),
          o = l.searchParams.get("sort_by");
        o && (i += `&sort_by=${o}`);
        let n = this.querySelector("[data-filter-availability]");
        n && !1 == i.includes("availability") && (i += `&${n.name}=1`),
          this.renderHtml(i);
      }
      onRemove(e) {
        e.preventDefault();
        let t = e.currentTarget.search.replace("?", "");
        this.renderHtml(t);
      }
      renderHtml(e) {
        let t = new URLSearchParams(window.location.search).get("q");
        t && !e.includes("q=") && (e = e ? `q=${t}&${e}` : `q=${t}`),
          this.updateURL(e);
        let i = `${window.location.pathname}?section_id=${this.dataset.id}&${e}`;
        this.setAttribute("loading", ""),
          fetch(i)
            .then((e) => e.text())
            .then((e) => {
              let t = new DOMParser()
                .parseFromString(e, "text/html")
                .querySelector("[data-collection-dynamic]");
              t &&
                (t.querySelector("grid-options") &&
                  (t.querySelector("grid-options").innerHTML =
                    document.querySelector("grid-options").innerHTML),
                t
                  .querySelector("[data-collection-list]")
                  .setAttribute(
                    "data-grid",
                    `${document
                      .querySelector("[data-collection-list]")
                      .getAttribute("data-grid")}`
                  ),
                (document.querySelector("[data-collection-dynamic]").innerHTML =
                  t.innerHTML),
                this.hasAttribute("open") &&
                  document
                    .querySelector("filters-component")
                    ?.setAttribute("open", ""),
                this.removeAttribute("loading"));
            });
      }
      updateURL(e) {
        history.pushState(
          { searchParams: e },
          "",
          `${window.location.pathname}${e && "?".concat(e)}`
        );
      }
      clear() {
        let e = "",
          t = window.location.search.split("&sort_by")[1];
        t && (e = `sort_by${t}`), this.renderHtml(e);
      }
      debounce = (e, t) => {
        let i;
        return (...r) => {
          clearTimeout(i), (i = setTimeout(() => e.apply(this, r), t));
        };
      };
    }
    customElements.define("filters-component", e);
  }
})();
